export const translations = {
  en: {
    nav: {
      home: '// HOME',
      services: '// SERVICES',
      builder: '// BUILDER',
      projects: '// PROJECTS',
      depot: '// DEPOT',
      contact: '// CONTACT',
      menu: '[MENU]'
    },
    hero: {
      headline_1: 'GRIND UNTIL',
      headline_2: 'IT WORKS.',
      subhead: 'Building robust software through sheer persistence and AI power.',
      cta: '[ EXECUTE PROJECT ]'
    },
    about: {
      title: 'System_Specs',
      text_1: "I am not a genius. I don't write clean code on the first draft. What I do have is",
      text_1_bold: "obsessive persistence",
      text_2: "While others rely on natural talent, I rely on",
      text_2_accent: "testing, fixing, and grinding",
      text_2_end: "until the solution is bulletproof. I treat software development not as an art, but as an industrial process of refinement.",
      stat_1: "Perspiration",
      stat_2: "Inspiration",
      terminal_title: "bash -- 80x24"
    },
    services: {
      title: 'The_Toolkit',
      s1_title: "Web Development",
      s1_desc: "React, PHP, SQL. From frontend beauty to backend logic. I build systems that scale.",
      s2_title: "IoT & Hardware",
      s2_desc: "Connecting the physical world. ESP32, Sensors, and Real-time Data processing.",
      s3_title: "AI Integration",
      s3_desc: "Empowering legacy systems with modern AI capabilities and LLM integration.",
      s4_title: "Project Management",
      s4_desc: "Turning chaos into structured deliverables. Agile workflows for hard deadlines."
    },
    consulting: {
      headline: '// SYSTEM_ARCHITECTURE',
      subhead: '"We don\'t just write code. We fix your chaos."',
      step1_title: "01. AUDIT & ANALYSIS",
      step1_desc: "We deploy onto your factory floor to analyze workflows, interview staff, and identify the invisible bottlenecks costing you money.",
      step2_title: "02. SYSTEM DESIGN",
      step2_desc: "No code is written until the blueprint is approved. We generate comprehensive Data Flow Diagrams (DFD) and tech roadmaps.",
      step3_title: "03. OPTIMIZATION",
      step3_desc: "We replace fragile Excel sheets with robust SQL databases, automating repetitive tasks and providing real-time BI dashboards."
    },
    techstack: {
      headline: '// WEAPONS_OF_CHOICE'
    },
    builder: {
      headline: './THE_BLUEPRINT_GENERATOR',
      subhead: '> Configure parameters to compile your digital presence.',
      panel_title: 'CONFIG_PANEL.exe',
      label_brand: 'Brand Name',
      label_tagline: 'Tagline',
      label_color: 'Theme Color',
      label_desc: 'Service Description',
      label_contact: 'Contact Email / Tel',
      btn_save: 'SAVE & CONTACT',
      btn_compiling: 'COMPILING...',
      btn_saved: 'BLUEPRINT SAVED',
      preview_nav_services: 'Services',
      preview_nav_about: 'About',
      preview_nav_contact: 'Contact',
      preview_btn: 'Get Started',
      preview_footer: 'All rights reserved.'
    },
    projects: {
      headline: 'Execution_Log',
      subhead: '> Displaying recent successful builds...',
      view_project: 'LIVE SYSTEM',
      p1_title: "IT Helpdesk Pro Max",
      p1_desc: "Web-based support system with AI Chatbot integration for automated ticket triage and resolution suggestions.",
      p1_status: "DEPLOYED",
      p2_title: "Vibration Monitor IoT",
      p2_desc: "Real-time dashboard monitoring industrial machine vibration sensors using ESP32 and WebSockets.",
      p2_status: "ONLINE",
      p3_title: "Environment Reporter",
      p3_desc: "Automated legacy system modernization tool for generating custom PDF reports from raw sensor logs.",
      p3_status: "STABLE"
    },
    depot: {
      headline: 'SOFTWARE_DEPOT',
      subhead: '> Battle-tested modules ready for deployment.',
      secure_badge: 'SECURE_TRANSACTION_PROTOCOL',
      cost: 'COST:',
      btn_inject: 'INJECT_CODE',
      prod1_desc: "Automated Line OA system for employee check-ins/outs with GPS tracking and monthly report generation.",
      prod2_desc: "Lightweight stock management dashboard with barcode scanner support and real-time alerts.",
      prod3_desc: "Complete source code + schematic for logging sensor data directly to Google Sheets without a backend server."
    },
    contact: {
      headline: 'Initialize_Communication',
      subhead: 'Connect to the mainframe.',
      label_name: 'enter_name:',
      label_email: 'enter_email:',
      label_msg: 'enter_message:',
      placeholder_name: '[Your Name]',
      placeholder_email: '[email@example.com]',
      placeholder_msg: '[System requires your input...]',
      btn_send: 'SEND_PACKET',
      btn_sending: 'TRANSMITTING...',
      btn_sent: 'PACKET_RECEIVED'
    },
    footer: {
      copyright: '© 2026 CoreStackDev Limited Partnership.',
      status: 'System Status: ONLINE. Errors: 0 (Finally).'
    },
    protection: {
      title: 'SYSTEM BREACH DETECTED',
      line1: '> UNAUTHORIZED DEBUGGING TOOLS IDENTIFIED.',
      line2: '> CONNECTION TERMINATED.',
      line3: '> IP ADDRESS LOGGED AND REPORTED.',
      error: 'Error Code: 0xDEADBEEF // GO_AWAY'
    },
    chat: {
      header: 'CORESTACK_CO-PILOT // ONLINE',
      welcome: 'CORESTACK_CO-PILOT // Connection established. System ready. What are we shipping today?',
      placeholder: 'Enter command or message...',
      processing: 'Processing logic...',
      cmd_diagnose: '/diagnose',
      cmd_diagnose_desc: 'Fix Bug',
      cmd_blueprint: '/blueprint',
      cmd_blueprint_desc: 'System Design',
      cmd_summary: '/summarize',
      cmd_summary_desc: 'Project Info',
      user: 'YOU',
      bot: 'CO-PILOT',
      responses: {
        default: "Acknowledged. Processing logic... Remember: Code that works and survives edge cases is what matters. Need specific analysis?",
        diagnose: "Running diagnostics... Please provide the Stack Trace or describe the symptoms. We'll drill down to the root cause and patch this.",
        blueprint: "Initializing architecture protocol... Scalability is key. Are we building a Microservice or Monolith today? Let's map the Data Flow first.",
        summary: "Compiling status report... CoreStackDev provides high-performance software development focused on robustness and efficiency.",
        price: "For pricing, please initialize communication via the Contact form below for a scope assessment. We focus on tangible value.",
        greeting: "Greetings. CoreStack Co-pilot ready for support. What is the mission?"
      }
    }
  },
  th: {
    nav: {
      home: '// หน้าหลัก',
      services: '// บริการ',
      builder: '// สร้างเว็บ',
      projects: '// ผลงาน',
      depot: '// ร้านค้า',
      contact: '// ติดต่อ',
      menu: '[เมนู]'
    },
    hero: {
      headline_1: 'ลุย จนกว่าจะ',
      headline_2: 'สำเร็จ',
      subhead: 'สร้างซอฟต์แวร์ที่แข็งแกร่ง ด้วยความพยายามอย่างบ้าคลั่งและพลัง AI',
      cta: '[ เริ่มโปรเจกต์ ]'
    },
    about: {
      title: 'สเปก_ระบบ',
      text_1: "ผมไม่ใช่อัจฉริยะ ผมไม่ได้เขียนโค้ดสะอาดตั้งแต่ดราฟต์แรก สิ่งที่ผมมีคือ",
      text_1_bold: "ความกัดไม่ปล่อย",
      text_2: "ในขณะที่คนอื่นพึ่งพาพรสวรรค์ ผมพึ่งพา",
      text_2_accent: "การทดสอบ แก้ไข และลุยแหลก",
      text_2_end: "จนกว่าโซลูชันจะกันกระสุน ผมไม่ได้มองการเขียนโปรแกรมเป็นศิลปะ แต่มองเป็นกระบวนการอุตสาหกรรมที่ต้องขัดเกลา",
      stat_1: "ความพยายาม",
      stat_2: "แรงบันดาลใจ",
      terminal_title: "เทอร์มินอล -- 80x24"
    },
    services: {
      title: 'เครื่องมือ_ของเรา',
      s1_title: "พัฒนาเว็บไซต์",
      s1_desc: "React, PHP, SQL จากหน้าบ้านที่สวยงามสู่หลังบ้านที่ซับซ้อน ผมสร้างระบบที่รองรับการขยายตัว",
      s2_title: "IoT & ฮาร์ดแวร์",
      s2_desc: "เชื่อมต่อโลกจริงด้วย ESP32, เซ็นเซอร์ และการประมวลผลข้อมูลแบบเรียลไทม์",
      s3_title: "AI Integration",
      s3_desc: "ยกระดับระบบเก่าด้วยความสามารถ AI สมัยใหม่และการเชื่อมต่อ LLM",
      s4_title: "บริหารจัดการโปรเจกต์",
      s4_desc: "เปลี่ยนความวุ่นวายให้เป็นงานที่จับต้องได้ ด้วย Agile Workflow สำหรับเดดไลน์ที่โหดหิน"
    },
    consulting: {
      headline: '// สถาปัตยกรรม_ระบบ',
      subhead: '"เราไม่ได้แค่เขียนโค้ด เราซ่อมความวุ่นวายของคุณ"',
      step1_title: "01. ตรวจสอบ & วิเคราะห์",
      step1_desc: "เราลงพื้นที่โรงงานของคุณเพื่อวิเคราะห์ขั้นตอนการทำงาน สัมภาษณ์พนักงาน และค้นหาคอขวดที่มองไม่เห็นซึ่งกำลังผลาญเงินคุณ",
      step2_title: "02. ออกแบบระบบ",
      step2_desc: "ไม่มีการเขียนโค้ดจนกว่าพิมพ์เขียวจะผ่านการอนุมัติ เราสร้าง Data Flow Diagrams (DFD) และแผนที่เทคโนโลยีที่ครอบคลุม",
      step3_title: "03. ปรับปรุงประสิทธิภาพ",
      step3_desc: "เราแทนที่ไฟล์ Excel ที่เปราะบางด้วยฐานข้อมูล SQL ที่แข็งแกร่ง เปลี่ยนงานซ้ำซากให้เป็นระบบอัตโนมัติ พร้อมแดชบอร์ด BI แบบเรียลไทม์"
    },
    techstack: {
      headline: '// อาวุธ_คู่กาย'
    },
    builder: {
      headline: './เครื่องมือ_สร้างพิมพ์เขียว',
      subhead: '> กำหนดค่าพารามิเตอร์เพื่อประมวลผลตัวตนบนโลกดิจิทัลของคุณ',
      panel_title: 'แผงควบคุม.exe',
      label_brand: 'ชื่อแบรนด์',
      label_tagline: 'สโลแกน',
      label_color: 'สีธีม',
      label_desc: 'รายละเอียดบริการ',
      label_contact: 'อีเมล / เบอร์ติดต่อ',
      btn_save: 'บันทึก & ติดต่อ',
      btn_compiling: 'กำลังประมวลผล...',
      btn_saved: 'บันทึกพิมพ์เขียวแล้ว',
      preview_nav_services: 'บริการ',
      preview_nav_about: 'เกี่ยวกับ',
      preview_nav_contact: 'ติดต่อ',
      preview_btn: 'เริ่มต้นใช้งาน',
      preview_footer: 'สงวนลิขสิทธิ์'
    },
    projects: {
      headline: 'บันทึก_การทำงาน',
      subhead: '> แสดงผลงานที่ประสบความสำเร็จล่าสุด...',
      view_project: 'ดูระบบจริง',
      p1_title: "IT Helpdesk Pro Max",
      p1_desc: "ระบบซัพพอร์ตบนเว็บพร้อม AI Chatbot ช่วยคัดกรองปัญหาและแนะนำวิธีแก้ไขอัตโนมัติ",
      p1_status: "ใช้งานจริง",
      p2_title: "Vibration Monitor IoT",
      p2_desc: "แดชบอร์ดเรียลไทม์สำหรับตรวจสอบการสั่นสะเทือนของเครื่องจักรในโรงงานด้วย ESP32 และ WebSockets",
      p2_status: "ออนไลน์",
      p3_title: "Environment Reporter",
      p3_desc: "เครื่องมืออัตโนมัติสำหรับแปลงระบบเก่า สร้างรายงาน PDF จากข้อมูลเซ็นเซอร์ดิบ",
      p3_status: "เสถียร"
    },
    depot: {
      headline: 'คลังแสง_ซอฟต์แวร์',
      subhead: '> โมดูลที่ผ่านสมรภูมิรบมาแล้ว พร้อมสำหรับการติดตั้ง',
      secure_badge: 'โปรโตคอล_ธุรกรรมปลอดภัย',
      cost: 'ราคา:',
      btn_inject: 'ฉีด_โค้ด',
      prod1_desc: "ระบบ Line OA อัตโนมัติสำหรับลงเวลาพนักงาน พร้อมติดตาม GPS และสร้างรายงานรายเดือน",
      prod2_desc: "แดชบอร์ดจัดการสต็อกแบบเบา รองรับเครื่องสแกนบาร์โค้ดและการแจ้งเตือนเรียลไทม์",
      prod3_desc: "ซอร์สโค้ดและวงจรครบชุดสำหรับบันทึกค่าเซ็นเซอร์ลง Google Sheets โดยตรง ไม่ต้องใช้เซิร์ฟเวอร์หลังบ้าน"
    },
    contact: {
      headline: 'เริ่มต้น_การสื่อสาร',
      subhead: 'เชื่อมต่อเข้าสู่เมนเฟรม',
      label_name: 'ระบุ_ชื่อ:',
      label_email: 'ระบุ_อีเมล:',
      label_msg: 'ระบุ_ข้อความ:',
      placeholder_name: '[ชื่อของคุณ]',
      placeholder_email: '[email@example.com]',
      placeholder_msg: '[ระบบต้องการข้อมูลจากคุณ...]',
      btn_send: 'ส่ง_แพ็กเก็ต',
      btn_sending: 'กำลังส่งข้อมูล...',
      btn_sent: 'ได้รับ_แพ็กเก็ตแล้ว'
    },
    footer: {
      copyright: '© 2026 ห้างหุ้นส่วนจำกัด คอร์สแต็คเดฟ (CoreStackDev)',
      status: 'สถานะระบบ: ออนไลน์. ข้อผิดพลาด: 0 (ในที่สุด)'
    },
    protection: {
      title: 'ตรวจพบการบุกรุกระบบ',
      line1: '> ตรวจพบเครื่องมือดีบักที่ไม่ได้รับอนุญาต',
      line2: '> ตัดการเชื่อมต่อทันที',
      line3: '> บันทึกและรายงานหมายเลข IP แล้ว',
      error: 'รหัสข้อผิดพลาด: 0xDEADBEEF // ออก_ไปซะ'
    },
    chat: {
      header: 'CORESTACK_CO-PILOT // ออนไลน์',
      welcome: 'CORESTACK_CO-PILOT // เชื่อมต่อสำเร็จ ระบบพร้อมทำงาน มีอะไรให้ช่วยลุยบ้างครับ?',
      placeholder: 'พิมพ์คำสั่งหรือข้อความ...',
      processing: 'กำลังประมวลผล',
      cmd_diagnose: '/diagnose',
      cmd_diagnose_desc: 'ช่วยแก้บั๊ก',
      cmd_blueprint: '/blueprint',
      cmd_blueprint_desc: 'ออกแบบระบบ',
      cmd_summary: '/summarize',
      cmd_summary_desc: 'ข้อมูลโครงการ',
      user: 'คุณ',
      bot: 'CO-PILOT',
      responses: {
         default: "รับทราบครับ กำลังประมวลผลตรรกะ... จำไว้เสมอ: โค้ดที่ทำงานได้จริงและทนทานคือสิ่งที่สำคัญที่สุด มีรายละเอียดเพิ่มเติมให้ผมช่วยวิเคราะห์ไหมครับ?",
         diagnose: "กำลังรันระบบตรวจสอบ... ขอ Stack Trace หรือเล่าอาการให้ฟังหน่อยครับ เราจะเจาะไปที่ต้นตอแล้วแก้บั๊กนี้ไปด้วยกัน อย่าเพิ่งท้อครับ",
         blueprint: "เริ่มกระบวนการออกแบบสถาปัตยกรรม... ความสามารถในการขยายตัว (Scalability) คือหัวใจสำคัญ วันนี้เราจะสร้าง Microservice หรือ Monolith ดีครับ? มาวางโครงสร้างข้อมูล (Data Flow) กันก่อน",
         summary: "กำลังรวบรวมรายงานสถานะ... CoreStackDev ให้บริการพัฒนาซอฟต์แวร์ระดับสูงที่เน้นความถึกทน (Robustness) และประสิทธิภาพ (Efficiency) เป็นหลักครับ",
         price: "สำหรับเรื่องราคา แนะนำให้ติดต่อผ่านฟอร์มด้านล่างเพื่อให้เราประเมินสโคปงานที่ชัดเจนก่อนครับ เราเน้นความคุ้มค่าและคุณภาพที่จับต้องได้",
         greeting: "สวัสดีครับ CoreStack Co-pilot พร้อมสนับสนุน ภารกิจวันนี้คืออะไร?"
      }
    }
  }
};